import { bank } from './bank/index';
import { fund } from './fund/index';
import { source } from './source/index';
import { taxFund } from './taxFund/index';
import { taxDistrict } from './taxDistrict/index';
import { taxUnit } from './taxUnit/index';
import { taxLevy } from './taxLevy/index';
import { commentTypes } from './taxCommentTypes/index';
import { taxReasonCode } from './taxReasonCode/index';
import { taxRollSummaryShared } from './taxRollSummaryShared/index';
import { taxMortgageCodesShared } from './taxMortgageCodesShared/index';
import { taxAdjTypesShared } from './taxAdjTypesShared/index';
import { taxStatusCodesShared } from './taxStatusCodesShared/index';
import { FeeTypes } from './feeTypes/index';
import { TaxAdditions } from './taxAdditions/index';
import { TaxStreets } from './taxStreets/index';
import { taxFeeMaster } from './taxFeeMaster/index';
import { remitUnit } from './remitUnits/index';

export const shared = {
  namespaced: true,
  modules: {
    bank,
    fund,
    source,
    taxFund,
    taxDistrict,
    taxUnit,
    taxLevy,
    commentTypes,
    taxRollSummaryShared,
    taxMortgageCodesShared,
    taxAdjTypesShared,
    taxStatusCodesShared,
    FeeTypes,
    TaxAdditions,
    TaxStreets,
    taxFeeMaster,
    remitUnit,
    taxReasonCode,
  },
};

export default shared;
